<template>
  <form class="w-100" @submit.prevent="submit">
    <div class="row">
      <div class="col-12 text-left">
        <button
          v-if="id !== 'new'"
          @click="del"
          type="button"
          class="btn btn-danger"
        >
          حذف داستان
          <i class="fas fa-trash" />
        </button>
        <button type="submit" class="btn btn-success mr-2">
          <span v-if="id !== 'new'">
            بروررسانی داستان
            <i class="far fa-save" />
          </span>
          <span v-else>
            ذخیره داستان جدید
            <i class="fas fa-plus" />
          </span>
        </button>

        <hr />
      </div>
      <div
        v-if="id === 'new' || (id !== 'new' && Object.keys(item).length)"
        class="col-12"
      >
        <div class="row">
          <div v-if="id !== 'new'" class="col-12 col-sm-6 col-lg-3">
            <StatsCard>
              <div class="icon-big text-center icon-info" slot="header">
                <i class="far fa-thumbs-up" />
              </div>
              <div class="numbers" slot="content">
                <p>تعداد لایک ها</p>
                {{ item.total_likes_count || "---" }}
              </div>
            </StatsCard>
          </div>
          <div v-if="id !== 'new'" class="col-12 col-sm-6 col-lg-3">
            <StatsCard>
              <div class="icon-big text-center icon-info" slot="header">
                <i class="far fa-eye" />
              </div>
              <div class="numbers" slot="content">
                <p>تعداد بازدید ها</p>
                {{ item.total_views_count || "---" }}
              </div>
            </StatsCard>
          </div>
          <div class="col-12">
            <card class="card" title="اطلاعات پایه">
              <div>
                <div class="form-row">
                  <div class="col-12 col-lg-4 mb-3">
                    <div class="form-group text-right">
                      <label for="title">عنوان</label>
                      <input
                        id="title"
                        type="text"
                        class="form-control"
                        placeholder="عنوان"
                        v-model="item.title"
                      />
                    </div>
                  </div>
                  <div class="col-12 col-lg-4 mb-3">
                    <div class="form-group text-right">
                      <label for="name">نام</label>
                      <input
                        id="name"
                        type="text"
                        class="form-control"
                        placeholder="نام"
                        v-model="item.name"
                      />
                    </div>
                  </div>
                  <div class="col-12 col-lg-4 mb-3">
                    <div class="form-group text-right">
                      <label for="url">url</label>
                      <input
                        dir="ltr"
                        id="url"
                        type="text"
                        class="form-control"
                        placeholder="url"
                        v-model="item.url"
                      />
                    </div>
                  </div>
                  <div class="col-12 col-lg-4 mb-3">
                    <div class="form-group text-right">
                      <label for="publish_date">زمان انتشار</label>
                      <appDatePicker
                        id="publish_date"
                        placeholder="زمان انتشار"
                        v-model="item.publish_date"
                        :multiple="true"
                      />
                    </div>
                  </div>

                  <div class="col-12 col-lg-4 mb-3">
                    <div class="form-group text-right">
                      <label for="categories">دسته بندی</label>
                      <appCategorySelect
                        id="categories"
                        placeholder="دسته بندی"
                        v-model="item.category_ids"
                        :multiple="true"
                      />
                    </div>
                  </div>
                  <div class="col-12 col-lg-4 mb-3">
                    <div class="form-group text-right">
                      <label for="minAge">حداقل سن</label>
                      <input
                        id="minAge"
                        type="number"
                        class="form-control"
                        placeholder="حداقل سن"
                        v-model.number="item.min_age"
                      />
                    </div>
                  </div>
                  <div class="col-12 col-lg-4 mb-3">
                    <div class="form-group text-right">
                      <label for="maxAge">حداکثر سن</label>
                      <input
                        id="maxAge"
                        type="number"
                        class="form-control"
                        placeholder="حداکثر سن"
                        v-model.number="item.max_age"
                      />
                    </div>
                  </div>
                  <div class="col-12 col-lg-4 mb-3">
                    <div class="form-group text-right">
                      <label for="order">ترتیب</label>
                      <input
                        id="order"
                        type="number"
                        class="form-control"
                        placeholder="ترتیب"
                        v-model.number="item.order"
                      />
                    </div>
                  </div>
                  <div class="col-12 col-lg-4 mb-3">
                    <div class="form-group text-right">
                      <label for="genders">جنسیت</label>
                      <appGendersSelect
                        id="genders"
                        placeholder="جنسیت"
                        v-model="item.genders"
                        :multiple="true"
                      />
                    </div>
                  </div>
                  <div class="col-12 col-lg-4 mb-3">
                    <div class="form-group text-right">
                      <label for="isSpecial">ویژه</label>
                      <fv-switch
                        id="isSpecial"
                        class="form-control d-block"
                        placeholder="ویژه"
                        v-model="item.is_special"
                      />
                    </div>
                  </div>
                  <div class="col-12 col-lg-4 mb-3">
                    <div class="form-group text-right">
                      <label for="enable">فعال</label>
                      <fv-switch
                        id="enable"
                        class="form-control d-block"
                        placeholder="فعال"
                        v-model="item.enabled"
                      />
                    </div>
                  </div>
                  <div class="col-12 col-lg-4 mb-3">
                    <div class="form-group text-right">
                      <label for="premium">داستان پولی</label>
                      <fv-switch
                        id="premium"
                        class="form-control d-block"
                        placeholder="پولی"
                        v-model="item.premium_required"
                      />
                    </div>
                  </div>
                </div>

                <div class="clearfix" />
              </div>
            </card>
          </div>
          <div v-if="item.premium_required" class="col-12">
            <card class="card" title="درصد هرکدام از سازنده‌های داستان">
              <div>
                <fvTable
                  class="fv-size-lg"
                  v-if="creators.length"
                  :fields="fields"
                  :rows="creators"
                >
                  <template slot="field-#" slot-scope="scope">
                    <!--                    <span>{{scope.index + 1 + ( (page - 1) * (pagination.page === 1 ? 0 : pagination.per_page ) )}}</span>-->
                    <span>{{ scope.index + 1 }}</span>
                  </template>
                  <template slot="field-نام" slot-scope="scope">
                    {{ scope.row.name || "" }} {{ scope.row.family_name || "" }}
                  </template>
                  <template slot="field-نقش" slot-scope="scope">
                    <div>
                      {{
                        scope.row.roleInStroy.map(
                          val =>
                            $store.state.main.usersRoles.find(
                              fVal => fVal.value === val
                            ).text
                        ) + ""
                      }}
                    </div>
                  </template>
                  <template slot="field-سهم" slot-scope="scope">
                    <div class="form-group text-right">
                      <label :for="`share${scope.index}`"></label>
                      <input
                        :id="`share${scope.index}`"
                        pattern="\d*"
                        maxlength="3"
                        type="text"
                        class="form-control"
                        placeholder="سهم"
                        @input="updatePercentage(scope.row, $event)"
                        :value="
                          item.shares.some(
                            val => val.account_id === scope.row.id
                          )
                            ? item.shares.find(
                                val => val.account_id === scope.row.id
                              ).percentage
                            : 0
                        "
                      />
                    </div>
                  </template>
                </fvTable>

                <div class="clearfix" />
              </div>
            </card>
          </div>
          <div class="col-12">
            <card class="card" title="مدیا">
              <div>
                <div class="form-row">
                  <div class="col-12">
                    <div class="form-group text-right">
                      <label for="media">فایل صوتی</label>
                      <appFileUploader
                        id="media"
                        v-model="item.media"
                        :type="['MP3', 'AMR', 'MPEG']"
                        :multiple="true"
                      />
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="form-group text-right">
                      <label for="gallery">گالری </label>
                      <appFileUploader
                        id="gallery"
                        v-model="item.gallery"
                        :multiple="true"
                      />
                    </div>
                  </div>

                  <div class="col-12">
                    <div class="form-group text-right">
                      <label for="banner">بنر</label>
                      <appFileUploader id="banner" v-model="item.banner" />
                    </div>
                  </div>

                  <div class="col-12">
                    <div class="form-group text-right">
                      <label for="video">ویدیو</label>
                      <appFileUploader
                        id="video"
                        v-model="item.videos"
                        :multiple="true"
                        :type="['VIDEO']"
                      />
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="form-group text-right">
                      <label for="color">رنگ پیش زمینه</label>
                      <appColorPicker
                        id="color"
                        v-model="item.background_color"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </card>
          </div>
          <div class="col-12">
            <card class="card" title="افراد">
              <div>
                <div class="form-row">
                  <div class="col-12 col-lg-4 mb-3">
                    <div class="form-group text-right">
                      <label for="writers">کارکتر(ها)</label>
                      <appUserSelect
                        selectByType
                        id="writers"
                        placeholder="کارکتر(ها)"
                        type="CHARACTER"
                        v-model="item.character_ids"
                        :multiple="true"
                      />
                    </div>
                  </div>
                  <div class="col-12 col-lg-4 mb-3">
                    <div class="form-group text-right">
                      <label for="writers">نویسنده(گان)</label>
                      <appUserSelect
                        id="writers"
                        placeholder="نویسندگان"
                        type="author"
                        v-model="item.author_ids"
                        @data=""
                        :multiple="true"
                      />
                    </div>
                  </div>
                  <div class="col-12 col-lg-4 mb-3">
                    <div class="form-group text-right">
                      <label for="narrators">راویان</label>
                      <appUserSelect
                        id="narrators"
                        placeholder="راویان"
                        type="narrator"
                        v-model="item.narrator_ids"
                        :multiple="true"
                      />
                    </div>
                  </div>
                  <div class="col-12 col-lg-4 mb-3">
                    <div class="form-group text-right">
                      <label for="illustrator">تصویرگر(ان)</label>
                      <appUserSelect
                        id="illustrator"
                        placeholder="تصویرگر(ان)"
                        type="illustrator"
                        v-model="item.illustrator_ids"
                        :multiple="true"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </card>
          </div>
          <div class="col-12">
            <card class="card" title="توضیحات">
              <div>
                <div class="form-row">
                  <div class="col-12">
                    <div class="form-group text-right">
                      <label for="description">توضیحات(حداکثر 20 کلمه)</label>
                      <appTextEditor
                        v-model="item.description"
                        id="description"
                        placeholder="توضیحات"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </card>
          </div>
          <div class="col-12">
            <card class="card" title="خلاصه داستان">
              <div>
                <div class="form-row">
                  <div class="col-12">
                    <div class="form-group text-right">
                      <label for="synopsis">خلاصه داستان</label>
                      <appTextEditor
                        v-model="item.synopsis"
                        id="synopsis"
                        placeholder="خلاصه داستان"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </card>
          </div>
          <div class="col-12">
            <card class="card" title="تاریخ نمایش">
              <div>
                <div class="form-row">
                  <div
                    class="col-12 col-lg-4 mb-3"
                    v-for="(val, i) in item.for_days"
                  >
                    <div class="form-group text-right d-flex flex-wrap">
                      <label class="w-100" :for="'for_days' + i">زمان</label>
                      <appDatePicker
                        id="publish_date"
                        placeholder="زمان"
                        v-model="item.for_days[i]"
                        :multiple="true"
                      />
                      <button
                        @click.prevent="item.for_days.splice(index, 1)"
                        class="btn btn-outline-danger mr-2"
                      >
                        پاک کردن
                        <i class="fa fa-trash" />
                      </button>
                    </div>
                  </div>
                  <div class="col-12 mt-3">
                    <button
                      @click.prevent="item.for_days.push('')"
                      class="btn btn-outline-primary"
                    >
                      اضافه کردن
                      <i class="fas fa-plus" />
                    </button>
                  </div>
                </div>
              </div>
            </card>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
import Modela from "modela";
import { mapActions } from "vuex";
import storyModel from "../../models/story";
import UserCard from "../UserProfile/UserCard.vue";
import MembersCard from "../UserProfile/MembersCard.vue";
import appDatePicker from "../../components/appDatePicker";
import appFileUploader from "../../components/appFileUploader";
import appUserSelect from "../../components/appUserSelect";
import appCategorySelect from "../../components/appCategorySelect";
import appGendersSelect from "../../components/appGendersSelect";
import appTextEditor from "../../components/appTextEditor";
import appColorPicker from "../../components/appColorPicker";
import { StatsCard } from "@/components/index";
import versionModel from "../../models/versions";
import AppFileUploader from "../../components/appFileUploader.vue";
// import appRepeatable from "../../components/appRepeatable";
export default {
  name: "story_edit",
  components: {
    StatsCard,
    UserCard,
    MembersCard,
    appFileUploader,
    appDatePicker,
    appUserSelect,
    appCategorySelect,
    appGendersSelect,
    appTextEditor,
    appColorPicker,
    AppFileUploader
    // appRepeatable
  },
  data() {
    const { params } = this.$route;
    const { id } = params;
    return {
      ...mapActions("main", ["crud"]),
      id,
      fields: ["#", "نام", "نقش", "سهم"],
      item: {},
      creators: []
    };
  },
  computed: {},
  methods: {
    async getData() {
      try {
        this.$store.commit("main/SET", { key: "loading", value: true });
        const story = await this.crud({
          action: "get",
          section: "stories",
          id: this.id,
          showError: true
        });
        if (story.data) {
          const result = story.data;
          let item = new Modela(storyModel);
          item = item.$clean();
          item = item.$set(result);
          this.item = item.$clean().$export();
          console.log("gallery", this.item);

          const authors = item.authors.map(val => {
            val.roleInStroy = ["author"];
            return val;
          });
          const illustrators = item.illustrators.map(val => {
            val.roleInStroy = ["illustrator"];
            return val;
          });
          const narrators = item.narrators.map(val => {
            val.roleInStroy = ["narrator"];
            return val;
          });
          const creators = [...authors, ...illustrators, ...narrators];
          const creatorsResult = [];
          creators.forEach(function(a) {
            if (!this[a.id]) {
              this[a.id] = a;
              creatorsResult.push(this[a.id]);
            } else {
              this[a.id].roleInStroy.push(a.roleInStroy[0]);
            }
          }, Object.create(null));
          this.creators = creatorsResult;
        }
      } catch (e) {
        console.log(e);
      } finally {
        this.$store.commit("main/SET", { key: "loading", value: false });
      }
    },
    async post() {
      try {
        if (this.item.premium_required) {
          if (
            this.item.shares.reduce((a, b) => (a = a + b.percentage), 0) >
              100 ||
            this.item.shares.reduce((a, b) => (a = a + b.percentage), 0) < 0
          ) {
            const message =
              "مجموع درصد افراد سازنده داستان باید بین 0 تا 100 باشد";
            return this.$errorAlert("خطا", message);
          }
        } else this.item.shares = [];
        console.log(`story is ${this.item}`);
        this.$store.commit("main/SET", { key: "loading", value: true });
        const newStory = await this.crud({
          action: "post",
          section: "stories",
          data: this.item,
          showError: true
        });
        this.$successAlert();
        this.$router.go(-1);
        // await this.$router.push({name: 'stories'})
      } catch (e) {
        // console.log(e)
      } finally {
        this.$store.commit("main/SET", { key: "loading", value: false });
      }
    },
    async put() {
      try {
        if (this.item.premium_required) {
          if (
            this.item.shares.reduce((a, b) => (a = a + b.percentage), 0) >
              100 ||
            this.item.shares.reduce((a, b) => (a = a + b.percentage), 0) < 0
          ) {
            const message =
              "مجموع درصد افراد سازنده داستان باید بین 0 تا 100 باشد";
            return this.$errorAlert("خطا", message);
          }
        } else this.item.shares = [];

        this.$store.commit("main/SET", { key: "loading", value: true });
        const updateStory = await this.crud({
          action: "put",
          section: "stories",
          id: this.id,
          data: this.item,
          showError: true
        });
        this.$successAlert();
        this.$router.go(-1);
        // await this.$router.push({name: 'stories'})
      } catch (e) {
        console.log(e);
      } finally {
        this.$store.commit("main/SET", { key: "loading", value: false });
      }
    },
    async del() {
      if (!(await this.$confirmAlert())) return false;
      try {
        this.$store.commit("main/SET", { key: "loading", value: true });
        const deleted = await this.crud({
          action: "delete",
          section: "stories",
          id: this.id,
          showError: true
        });
        await this.$successAlert();
        // await this.$router.push({name: 'stories'})
        this.$router.go(-1);
      } catch (e) {
        // console.log(e)
      } finally {
        this.$store.commit("main/SET", { key: "loading", value: false });
      }
    },
    async submit() {
      if (this.id !== "new") this.put();
      else this.post();
    },
    updatePercentage(item, event) {
      const value = parseFloat(event.target.value);
      if (!value && value !== 0) return;

      if (this.item.shares.some(val => val.account_id === item.id))
        this.item.shares = this.item.shares.map(val => {
          if (val.account_id === item.id) {
            val.percentage = value;
          }
          return val;
        });
      else this.item.shares.push({ account_id: item.id, percentage: value });
    }
  },
  async created() {
    if (this.id !== "new") await this.getData();
    else {
      let item = new Modela(storyModel);
      this.item = item.$clean().$export();
    }
  }
};
</script>
<style></style>
